import { atom } from "jotai";

export type CropZoomSelection = {
    originalUrl?: string;
    originalSize?: { width: number; height: number };
    onResolve?: (newUrl?: string) => void;
};

export const cropZoomSelectionAtom = atom<CropZoomSelection>();
